<template>
  <div class="carousel-container">
    <div class="carousel-mask"></div>
    <div class="title-container ">
      <div class="main-logo animate__animated" :class="addAnimate"><img :src="logoUrl" alt="" srcset=""><p>华艺元界</p></div>
      <p class="animate__animated " :class="addAnimate">链上华艺，元启未来</p>
      <div class="desc">
        <span>打造开放包容的平台，为所有热爱艺术的人群服务，为各个领域流派的艺术家服务,</span>
        <span>为多元共生的艺术文化交流而服务。</span>
      </div>
    </div>
    <div class="more">
     <double-down theme="outline" size="24" />
      <span>滚动查看更多</span>
    </div>
  </div>
</template>

<script>
import { DoubleDown } from '@icon-park/vue'
export default {
  data () {
    return {
     logoUrl: require('@/assets/imgs/logoW.png')
    }
  },
  props: ['addAnimate'],
components: {
  DoubleDown
}
}
</script>

<style lang="less" scoped>
@keyframes jump-down {
  0% {
    transform: translateY(-3px);
  }

  50% {
    transform: translateY(3px);
  }

  100% {
    transform: translateY(-3px);
  }
}

.carousel-container {
  position: relative;
  width: inherit;
  height: inherit;
  background-image: url('~@/assets/imgs/bg.jpeg');
  background-size: cover;
  background-position: center;
  .carousel-mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3)
  }

  .title-container {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    color: #fff;
    top: 50%;
    left: 32px;
    transform: translateY(-50%);
    .main-logo{
      display: flex;
      align-content: center;
      img{
        width: 64px;
        height: 64px;
        margin-right: 10px;
      }
      p{
        display: block;
        width: auto;
        line-height: 64px;
        font-size: 46px !important;
      }
    }

    p {
      letter-spacing: .5rem;
      display: block;
      width: auto;
      font-size: 48px;
      text-align: start;
      font-weight: 700;
      padding-bottom: 20px;
    }
    .desc {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 700px !important;
      height: 100px;
      border: #fff 2px solid;
      border-radius: 100px;
      width: 100%;
      overflow: hidden;
      span{
        font-size: 18px;
        font-weight: 700;
        line-height: 30px;
      }
    }

  }

  .more {
    position: absolute;
    bottom: 32px;
    left: 50%;
   transform: translateX(-50%) !important;
    display: flex;
    width: 150px;
    animation: jump-down 2s infinite;
    color: #fff;
    z-index: 2;

    span {
      display: block;
      height: 24px;
      text-indent: 5px;
      line-height: 24px;
    }
  }

}
</style>